// Состояние пароля для защищённых экранов: плашка, пункт меню, перенаправление.
//
// Перечитывается при смене адреса: администратор мог назначить смену, пока
// человек работал, и узнать об этом нужно без перезагрузки страницы. Запрос
// дешёвый (одна строка настроек и поле даты), ответ не кешируется.

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchPasswordState, type PasswordState } from './passwordApi';

export function usePasswordState(enabled = true): PasswordState | null {
  const { pathname } = useLocation();
  const [state, setState] = useState<PasswordState | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    fetchPasswordState()
      .then((fresh) => !cancelled && setState(fresh))
      .catch(() => {
        // Недоступный бэкенд не должен ломать экран: без состояния плашки
        // просто нет, а запрет работы с просроченным паролем всё равно
        // держится на сервере.
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, pathname]);

  return state;
}
